import { FC } from "react"
import Skeleton from "../base"

interface ActivityHistorySkeletonProps {
  rows?: number
  className?: string
}

const ActivityHistorySkeleton: FC<ActivityHistorySkeletonProps> = ({
  rows = 3,
  className = ""
}) => {
  return (
    <div className={className}>
      <Skeleton>
        {Array.from({ length: rows }).map((_, index) => (
          <div key={index} className="flex items-center py-4 max-w-xl">
            <div className="flex items-center">
              <div className="rounded-full bg-gray-200 w-12 h-12"></div>
              <div className="ml-4">
                <div className="h-5 bg-gray-200 rounded-full w-56"></div>
              </div>
            </div>
            <div className="text-neutral-400 ml-24 hidden md:block">
              <div className="h-5 bg-gray-200 rounded-full w-40"></div>
            </div>
          </div>
        ))}
      </Skeleton>
    </div>
  )
}

export default ActivityHistorySkeleton
